export const OBSERVER_IMAGE = 'image'
export const OBSERVER_COMPONENT = 'component'
export const OBSERVER_BRIGHTCOVE_VIDEO = 'brightcoveVideo'
export const OBSERVER_PAGINATION_PAGE = 'paginationPage'
